import { React, useState } from "react";
import VideoPlayer from "./videoPlayer";
import axios from "axios";
import { API_BASE } from "../Utils/constant";
import { AUTH_TOKEN } from "../constants/localStorageKeys";
import { retrieve } from "../helpers/StorageHelper";

/**
 * CoursesChapter component
 * @param {Object} props
 * @param {string} props.videoSrc - Video source URL
 * @param {string} props.moduleTitle - Title of the module
 * @param {string} props.chapterTitle - Title of the chapter
 * @param {number} props.chapterNo - Chapter number
 * @param {string} props.vedioDescription - Chapter description
 * @param {boolean} props.videoCompleted - Whether video is completed
 * @param {function} props.onVideoComplete - Function to mark video as completed
 * @param {function} props.onClickBtn - Function to proceed to next chapter
 * @param {number} props.moduleProgress - Module completion percentage
 */

export default function CoursesChapter({
  index,
  videoSrc,
  moduleTitle,
  chapterTitle,
  chapterNo,
  vedioDescription,
  videoCompleted,
  onVideoComplete,
  onClickBtn,
  moduleProgress,
}) {
  const [videoEnded, setVideoEnded] = useState(false);

  const handleVideoEnd = () => {
    setVideoEnded(true);
  };

  const handleMarkComplete = async () => {
    onVideoComplete(); // Update local state
    setVideoEnded(false);
    const token = retrieve(AUTH_TOKEN);
    const moduleId = retrieve("moduleId");

    try {
      const response = await axios.post(
        `${API_BASE}/user/modules/${moduleId}/chapters/${chapterNo}/complete`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );


      onClickBtn(); // Proceed to next chapter
    } catch (error) {
      console.error("Error marking chapter as complete", error);
      // Roll back local state if API call fails
      onVideoComplete(false);
    }
  };

  return (
    <div className="module-details-container">
      <div className="module-video-title-container">
        <span
          className="text-body-b4"
          style={{ color: "var(--Text-100, #d0d8df)" }}
        >
          {`${
            Number.isInteger(moduleProgress)
              ? moduleProgress
              : moduleProgress.toFixed()
          }% Complete`}
          <span className={`title-complete ${videoCompleted ? "d-none" : ""}`}>
            - {moduleTitle}
          </span>
        </span>
        <div className="module-progress-bar">
          <div
            className="module-progress-bar-progress"
            style={{ width: `${moduleProgress}%` }}
          ></div>
        </div>
        <h2
          className="text-heading-h3 mb-0"
          style={{ color: "var(--Text-100, #d0d8df)" }}
        >
          Chapter {index} - {chapterTitle}
        </h2>
      </div>
      {videoSrc && (
        <VideoPlayer
          videoSrc={videoSrc}
          videoCompleted={videoCompleted}
          onVideoComplete={onVideoComplete}
          onVideoEnd={handleVideoEnd}
        />
      )}

      <div className="module-video-description">
        <h3 className="text-body-b2 mb-0" style={{ color: "#e6ecf1" }}>
          Description
        </h3>
        <span
          className="text-body-b3"
          style={{ color: "#d0d8df" }}
          dangerouslySetInnerHTML={{ __html: vedioDescription }}
        />
      </div>
      <div className="module-button-container">
        <button
          className="btn-1 markCompleteBtn btn-1-primary text-body-b1"
          style={{ width: "240px" }}
          disabled={(videoSrc && !videoEnded) || videoCompleted}
          onClick={handleMarkComplete}
        >
          {videoCompleted ? "Completed" : "Mark as Complete"}
        </button>
        <div className="d-flex gap-2 mark-complete-btn-courses">
          <img alt="image-alt" src="/icons/module-arrow-left.svg" />
          <span className="text-body-b3" style={{ color: "#c8ced3" }}>
            Tap to proceed to the next video.
          </span>
        </div>
      </div>
    </div>
  );
}
